    var swiper = new Swiper(".mySwiper", {
      slidesPerView:2,
      spaceBetween: 60,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
           breakpoints: {
        480: {
          slidesPerView: 3,
          spaceBetween: 60,
        },
        750: {
          slidesPerView: 4,
          spaceBetween: 60,
        },
        1000: {
          slidesPerView: 6,
          spaceBetween: 60,
        },
      }
    });